import { render, staticRenderFns } from "./palletinfodashboard.vue?vue&type=template&id=61fbc6c8"
import script from "./palletinfodashboard.vue?vue&type=script&lang=js"
export * from "./palletinfodashboard.vue?vue&type=script&lang=js"
import style0 from "./palletinfodashboard.vue?vue&type=style&index=0&id=61fbc6c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports